(() => {
  const config = window.DacostaRecurrente || {};
  const workerBase = String(config.workerBase || "").replace(/\/$/, "");
  const measurementId = String(config.measurementId || "");
  const checkoutSelectors = config.selectors || ["#Recurrente-Cart-Checkout", "#Recurrente-Checkout", "[data-recurrente-checkout]"];
  let active = false;

  persistAttribution();

  document.addEventListener("click", async (event) => {
    const buyNow = event.target.closest("[data-recurrente-buy-now]");
    const cartCheckout = checkoutSelectors.map((selector) => event.target.closest(selector)).find(Boolean);
    const button = buyNow || cartCheckout;
    if (!button || active || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    if (!workerBase) return showError(button, "El pago todavía no está configurado.");

    if (!document.querySelector("[data-recurrente-name]")) {
      if (buyNow) {
        try {
          await addProductToCart(button);
          location.assign("/cart");
        } catch (error) {
          showError(button, error.message || "No pudimos agregar el producto al carrito.");
        }
      } else {
        location.assign("/cart");
      }
      return;
    }

    active = true;
    const labelNode = button.querySelector(".button-text") || button;
    const label = labelNode.textContent;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    labelNode.textContent = "Preparando pago…";

    try {
      validateCheckoutDetails();
      const items = buyNow ? readProductSelection(button) : await readCartItems();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "begin_checkout", ecommerce: { currency: "GTQ", items: items.map((item) => ({ item_id: String(item.variant_id), quantity: item.quantity })) } });
      await beginCheckout(items);
    } catch (error) {
      showError(button, error.message || "No pudimos iniciar el pago.");
      button.disabled = false;
      button.removeAttribute("aria-busy");
      labelNode.textContent = label;
      active = false;
    }
  }, true);

  document.addEventListener("shopify:cart:lines-update", (event) => {
    const completion = event.promise;
    if (completion && typeof completion.then === "function") {
      completion.then(refreshCartCount).catch(() => refreshCartCount());
    } else {
      refreshCartCount();
    }
  });
  document.addEventListener("shopify:cart:update", refreshCartCount);
  window.addEventListener("pageshow", refreshCartCount);

  if (new URLSearchParams(location.search).get("clear_cart") === "1") {
    fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" }).then(refreshCartCount).catch(() => {});
  } else {
    refreshCartCount();
  }

  async function beginCheckout(items) {
    if (!items.length) throw new Error("Tu carrito está vacío.");
    const payload = {
      cart_token: await readCartToken(),
      items,
      customer: readCustomer(),
      shipping_address: readShipping(),
      discount_code: await readDiscountCode(),
      attribution: await readAttribution(),
      note: readValue("[name='note'], #Cart-note, #CartDrawer-Note"),
      success_url: `${location.origin}/pages/gracias`,
      cancel_url: location.href,
    };
    const response = await fetch(`${workerBase}/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.checkout_url) {
      if (response.status === 409) throw new Error("Este producto cambió de disponibilidad. Actualiza la página e inténtalo de nuevo.");
      throw new Error(data.details || data.message || "No pudimos iniciar el pago. Inténtalo nuevamente.");
    }
    location.assign(data.checkout_url);
  }

  function readProductSelection(button) {
    const form = button.closest("form") || button.closest("product-form-component")?.querySelector("form");
    const variantId = form?.querySelector('[name="id"]')?.value;
    const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    if (!variantId) throw new Error("Selecciona una variante disponible.");
    return [{ variant_id: variantId, quantity: Number.isInteger(quantity) && quantity > 0 ? quantity : 1 }];
  }

  async function addProductToCart(button) {
    const item = readProductSelection(button)[0];
    const response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: item.variant_id, quantity: item.quantity }] }),
    });
    if (!response.ok) throw new Error("Este producto no está disponible en la cantidad seleccionada.");
  }

  async function readCart() {
    const response = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("No pudimos leer tu carrito.");
    return response.json();
  }
  async function readCartItems() {
    const cart = await readCart();
    return (cart.items || []).map((item) => ({ variant_id: item.variant_id, quantity: item.quantity }));
  }
  async function readCartToken() {
    try { return (await readCart()).token || ""; } catch { return ""; }
  }
  async function refreshCartCount() {
    try {
      const cart = await readCart();
      const count = Number(cart.item_count || 0);
      document.querySelectorAll(".rc-header__cart-count").forEach((node) => {
        node.textContent = String(count);
        node.hidden = count < 1;
      });
      document.querySelectorAll(".rc-header__cart").forEach((link) => {
        link.setAttribute("aria-label", `Carrito, ${count} ${count === 1 ? "artículo" : "artículos"}`);
      });
    } catch {}
  }
  function readValue(selector) { return document.querySelector(selector)?.value?.trim() || ""; }
  async function readDiscountCode() {
    const direct = (readValue("[data-recurrente-discount], [name='discount']") || sessionStorage.getItem("dacosta_discount_code") || "").toUpperCase();
    if (direct) return direct;
    try {
      const cart = await readCart();
      return String((cart.cart_level_discount_applications || []).find((item) => String(item.title || "").toUpperCase() === "DAWELCOME10")?.title || "").toUpperCase();
    } catch { return ""; }
  }
  function readCustomer() {
    const fullName = readValue("[data-recurrente-name], #rm-full-name, #rm-cart-full-name");
    const parts = fullName.split(/\s+/).filter(Boolean);
    return { email: readValue("[data-recurrente-email], #rm-email, #rm-cart-email"), phone: readValue("[data-recurrente-phone], #rm-phone, #rm-cart-phone"), first_name: parts.shift() || "", last_name: parts.join(" ") };
  }
  function readShipping() {
    return { address1: readValue("[data-recurrente-address], #rm-address, #rm-cart-address"), address2: readValue("[data-recurrente-address2]"), city: readValue("[data-recurrente-city], #rm-location, #rm-cart-location"), province: readValue("[data-recurrente-province], #rm-province, #rm-cart-province"), zip: readValue("[data-recurrente-zip]") };
  }
  function persistAttribution() {
    const params = new URLSearchParams(location.search);
    const current = readStoredAttribution();
    ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((key) => {
      const value = params.get(key);
      if (value) current[key] = value.slice(0, 500);
    });
    if (!current.landing_page) current.landing_page = location.href.slice(0, 1000);
    current.page_location = location.href.slice(0, 1000);
    try { localStorage.setItem("dacosta_attribution", JSON.stringify(current)); } catch {}
  }
  function readStoredAttribution() {
    try { return JSON.parse(localStorage.getItem("dacosta_attribution") || "{}"); } catch { return {}; }
  }
  async function readAttribution() {
    const stored = readStoredAttribution();
    const consent = readAnalyticsConsent();
    if (consent === "denied") return { consent };
    const [clientId, sessionId] = await Promise.all([
      googleValue("client_id", cookieClientId()),
      googleValue("session_id", cookieSessionId())
    ]);
    return {
      ...stored,
      client_id: String(clientId || "").slice(0, 100),
      session_id: String(sessionId || "").slice(0, 100),
      consent,
      user_agent: navigator.userAgent.slice(0, 500)
    };
  }
  function googleValue(field, fallback) {
    return new Promise((resolve) => {
      if (!measurementId || typeof window.gtag !== "function") return resolve(fallback || "");
      let settled = false;
      const timer = setTimeout(() => { if (!settled) { settled = true; resolve(fallback || ""); } }, 800);
      try {
        window.gtag("get", measurementId, field, (value) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(value || fallback || "");
        });
      } catch {
        clearTimeout(timer);
        resolve(fallback || "");
      }
    });
  }
  function cookieClientId() {
    const value = cookieValue("_ga");
    const match = value.match(/GA\d+\.\d+\.(\d+\.\d+)$/);
    return match?.[1] || "";
  }
  function cookieSessionId() {
    if (!measurementId) return "";
    const value = cookieValue(`_ga_${measurementId.replace(/^G-/, "").replace(/-/g, "_")}`);
    const match = value.match(/(?:^|\.)s(\d+)(?:\.|$)/);
    return match?.[1] || "";
  }
  function cookieValue(name) {
    const prefix = `${name}=`;
    const item = document.cookie.split("; ").find((part) => part.startsWith(prefix));
    return item ? decodeURIComponent(item.slice(prefix.length)) : "";
  }
  function readAnalyticsConsent() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === "function") return privacy.analyticsProcessingAllowed() ? "granted" : "denied";
    } catch {}
    return "unknown";
  }
  function validateCheckoutDetails() {
    const required = [
      ["[data-recurrente-name]", "Ingresa tu nombre completo."],
      ["[data-recurrente-email]", "Ingresa tu correo electrónico."],
      ["[data-recurrente-phone]", "Ingresa tu teléfono."],
      ["[data-recurrente-address]", "Ingresa tu dirección de entrega."],
      ["[data-recurrente-city]", "Ingresa tu municipio o ciudad."],
      ["[data-recurrente-province]", "Selecciona tu departamento."]
    ];
    for (const [selector, message] of required) {
      const field = document.querySelector(selector);
      if (!field || !field.value.trim()) {
        field?.focus();
        throw new Error(message);
      }
    }
    const email = readValue("[data-recurrente-email]");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error("Ingresa un correo electrónico válido.");
  }
  function showError(button, message) {
    let node = button.parentElement?.querySelector("[data-recurrente-error]");
    if (!node) {
      node = document.createElement("p");
      node.dataset.recurrenteError = "";
      node.setAttribute("role", "alert");
      node.style.cssText = "margin:12px 0 0;color:#a33;font-size:13px;line-height:1.4";
      button.insertAdjacentElement("afterend", node);
    }
    node.style.display = "block";
    node.textContent = message;
  }
})();